/** 产品库拉取失败时触发按钮上的字(调用方自定义 triggerLabel 时也用这句,口径一致)。 */
export const PRODUCT_LOAD_FAILED_TRIGGER = "产品库没读到 · 点开重试";
